import { atom } from 'jotai';

export const FTOAccessedViaAppLinkAtom = atom<boolean>(false);
